import { render } from "./header-content.vue?vue&type=template&id=2857f4b0&ts=true"
import script from "./header-content.vue?vue&type=script&lang=ts"
export * from "./header-content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__